import React from 'react';
import moment from 'moment';
import NoDataMsg from 'library/noData';

const Body = ({ discrepancyReport, endDate, beginDate }) => (

    <div>
        {
            discrepancyReport.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div>
                    <div className="row m-0">
                        <div className="text-center list_header">
                            {beginDate ?
                                <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                    {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                : ""}
                        </div>
                    </div>
                    <div className="table-responsive">
                        {
                            discrepancyReport.map((item, index) => {

                                return (
                                    <div className="row m-0 mb-2" key={index}>

                                        <div className="col-lg-12 text-center daily_cash border-right">
                                            <div className="row m-0">
                                                <div className="col-lg-8 col-md-4 col-sm-12 col-xs-12 m-0 p-0">
                                                    {/* STORE CREDIT */}
                                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0">
                                                        <label>Category</label>
                                                        <h3 className="m-0 grey-text">{item.category}</h3>
                                                    </div>

                                                    {/* DEBIT CARD */}
                                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 m-0 p-0">
                                                        <label>SKU</label>
                                                        <h3 className="m-0 grey-text">{item.sku}</h3>
                                                    </div>

                                                    {/* CREDIT CARD */}
                                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 m-0 p-0">
                                                        <label>UPC</label>
                                                        <h3 className="m-0 grey-text">{item.upc}</h3>
                                                    </div>
                                                </div>

                                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 m-0 p-0">
                                                    {/* DISCOUNTS */}
                                                    <div className="col-lg-6 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0">
                                                        <label>Unit Of Measure</label>
                                                        <h3 className="m-0 danger">{item.unitOfMeasure}</h3>
                                                    </div>

                                                    {/* RECEIVED CASH */}
                                                    <div className="col-lg-6 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0">
                                                        <label>balance Per Book</label>
                                                        <h3 className="m-0 green-text">{item.balancePerBook}</h3>
                                                    </div>



                                                </div>
                                            </div>
                                        </div>{/* Column Icons */}


                                    </div>
                                );
                            })
                        }

                    </div>
                </div>
        }
    </div>
);

export default Body;